import * as React from "react";
import Partner from "../../../classes/Partner";

import AppContext from "../AppContext";
import api from "../../api";
import Lead from "../../../classes/Lead";
import Section from "../Section/Section";

import { _t } from "../../../utils/Translator";

type LeadSectionProps = {
  partner: Partner;
  canCreatePartner: boolean;
};

type SectionLeadsState = {
  leads: Lead[];
};

class SectionLeads extends React.Component<LeadSectionProps, SectionLeadsState> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      // Keep section semantics strict: only explicit leads belong here.
      leads: (this.props.partner.leads || []).filter(lead => lead.type === "lead")
    };
  }

  private getLeadDescription = (lead: Lead): string => {
    const expectedRevenueString = _t(
      lead.recurringPlan
        ? "%(expected_revenue)s + %(recurring_revenue)s %(recurring_plan)s at %(probability)s%"
        : "%(expected_revenue)s at %(probability)s%",
      {
        expected_revenue: lead.expectedRevenue,
        recurring_revenue: lead.recurringRevenue,
        recurring_plan: lead.recurringPlan,
        probability: lead.probability
      }
    );

    return expectedRevenueString;
  };

  render() {
    return (
      <Section
        records={this.state.leads}
        partner={this.props.partner}
        canCreatePartner={this.props.canCreatePartner}
        model="crm.lead"
        odooEndpointCreateRecord={api.createLead}
        odooRecordIdName="lead_id"
        odooRedirectAction="crm_mail_plugin.crm_lead_action_form_edit"
        onClickCreate={callback => callback({ type: "lead" })}
        title="Leads"
        titleCount="Leads (%(count)s)"
        msgNoPartner="Save Contact to create new Lead."
        msgNoPartnerNoAccess="The Contact needs to exist to create Lead."
        msgNoRecord="No leads found for this contact."
        msgLogEmail="Log Email Into Lead"
        getRecordDescription={this.getLeadDescription}
      />
    );
  }
}

SectionLeads.contextType = AppContext;

export default SectionLeads;
